import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr} from '../utils.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Menu from '../cmp/menu'
import icon from '../icons.svg'

function CatReasonsList({data=undefined,actions,choice=false}){

    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    const Data=context.data['catReasons']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const glStatus=context.status

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'catReas',sortable:false},
        {caption:'id',minWidth:'15',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'160',dataId:'name',sortable:true},
        {caption:localestr('Офіціант'),minWidth:'20',dataId:'use_offic',sortable:true,typeCol:'check'},
        {caption:localestr('Кухня'),minWidth:'20',dataId:'use_kitch',sortable:true,typeCol:'check'},
        {caption:localestr('Друк'),minWidth:'20',dataId:'prn_ret',sortable:true,typeCol:'check'},
    ]

    const filterData=[ //+
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'},
        {caption:localestr('Доступно офіціанту'),dataId:'use_offic',typeVal:'selYN'},
        {caption:localestr('Доступно кухні'),dataId:'use_kitch',typeVal:'selYN'},
        {caption:localestr('Без списання'),dataId:'no_prod',typeVal:'selYN'},
        {caption:localestr('Друк відмови'),dataId:'prn_ret',typeVal:'selYN'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        let ierarc=1
        if(showAFilter) ierarc=0
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(!showAFilter) setWndData({...wndData,ierarc,filter:undefined,showAFilter})
        else setWndData({...wndData,ierarc,showAFilter})
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item,use_offic:(item.can_use&1).toString(),use_kitch:(item.can_use&2?1:0).toString(),no_prod:item.no_product>0?'1':'0',prn_ret:item.no_product>1?'1':'0'}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const newItem=()=>{tabNew('catReasons_edit',localestr('Шаблон відмови')+' *',{})}

    const editItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('catReasons_edit',localestr('Шаблон відмови')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol})
            //console.log(wndData.currentCol)
        }
    }

    const copyItem=()=>{
        let item={...wndData.currentCol}
        delete item.id
        if (typeof wndData.currentCol === 'object') {
            tabNew('catReasons_edit',localestr('Шаблон відмови')+' *',item)
            //console.log(wndData.currentCol)
        }
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice===2) {tabChoice(wndData.currentCol)}
            else if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            let newData={status:'rem',key:'CatReasons',data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
            saveData(newData,()=>{})
        }
    }

    const transferItem=(item,target)=>{
        if (typeof item === 'object') {
            let newData={status:'mod',key:'CatReasons',data:{...item,parent:target}}
            saveData(newData,()=>{})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:'catReasons'}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            const type='catReasons'
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const hDragDrop=(item,target)=>{
        if(item.isfolder && item.id===target.id) return
        if(item.parent.id===target.id) return
        if(item.id===target.parent.id) return
        if(target.parent.parent) {
            if(item.id===target.parent.parent.id) return
            if(target.parent.parent.parent) {
                if(item.id===target.parent.parent.parent.id) return
                if(target.parent.parent.parent.parent) {
                    if(item.id===target.parent.parent.parent.parent.id) return
                    
                }
            }
        }
        msg('Перемістити '+item.name+' у '+target.name+'?',localestr('Переміщення'),[{caption:localestr('Так'),action:()=>{transferItem(item,target)}},{caption:localestr('Ні'),action:()=>{}}])
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData('catReasons')
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data])

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData('catReasons')}},
        //{name:localestr('Групова зміна'),icon:'#hisBut',action:grpEdit},
    ]
    if(choice) menuData.splice(0,2)


    return(
        <>
        
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)',width:'100%'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('catReasons_edit',localestr('Шаблон відмови')+' *')}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={editItem} onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}
            ><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={removeItem} onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}
            ><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}} onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}
            ><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            <div style={{flexGrow:'10'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} Caption={localestr('Шаблони відмови')} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} hDragDrop={hDragDrop} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatReasonsList